/*
Usage:
    // with http://example.com?paramA=valueA&paramB=valueB
    getQueryParam('paramA');    // return valueA
    getQueryParam('paramB');    // return valueB
    getQueryParam('paramC');    // return null
*/
export function getQueryParam(name: string): string | null {
    const regex = new RegExp('[?&]' + name + '=([^&#]*)');
    const q = regex.exec(window.location.search);
    return q && q[1];
}